import type { Client } from '@bugsnag/js'
import { fromJS } from 'immutable'

const transformImmutable = (x: any) => fromJS(x).toJS()

// error is of type any because we don't know what type of error is being caught by catch clauses
// it could be Error but also anything else
const logError = <S extends { app: any; auth?: any }>(errorMsg: string, error: any, state?: S, extraMeta = {}) => {
  const meta = transformImmutable({
    errorMsg,
    error,
    app: state?.app,
    auth: state?.auth,
    state,
    ...extraMeta,
  })

  if (!window.location.href.match('albacross.com')) {
    console.error(errorMsg, ':', error)
    meta && console.debug(meta)
  }

  const bugsnag: Client = (window as any).Bugsnag
  if (typeof bugsnag !== 'undefined' && typeof bugsnag.notify === 'function') {
    bugsnag.notify(error, event => {
      event.addMetadata('custom', meta)
    })
  }
}

export default logError
